module.exports = __webpack_public_path__ + "static/media/logo-appstore@2x.13eea2ac.png";